import { SchemeTypes } from '../../../../config';
import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  first_supply_header: {
    [LanguagesEnum.English]: 'First Supply Details',
    [LanguagesEnum.Greek]: 'Λεπτομέρειες πρώτης προμήθειας',
  },
  date_of_first_supply_label: {
    [LanguagesEnum.English]: 'Date of First Supply',
    [LanguagesEnum.Greek]: 'Ημερομηνία πρώτης προμήθειας',
  },
};

export const CanModify = {
  [SchemeTypes.EU]: (is_agent?: boolean): string[] => {
    return ['firstSupplyDetails_dateOfFirstSupply'];
  },
  [SchemeTypes.NON_EU]: (is_agent?: boolean): string[] => {
    return ['firstSupplyDetails_dateOfFirstSupply'];
  },
  [SchemeTypes.IOSS]: (is_agent: boolean): string[] => {
    if (is_agent) {
      return ['firstSupplyDetails_dateOfFirstSupply'];
    } else {
      return ['firstSupplyDetails_dateOfFirstSupply'];
    }
  },
};

export default CONFIGURATION;
